import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-broadcasting-gallery-zoom-dialog',
  templateUrl: './broadcasting-gallery-zoom-dialog.component.html',
  styleUrls: ['./broadcasting-gallery-zoom-dialog.component.scss']
})
export class BroadcastingGalleryZoomDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<BroadcastingGalleryZoomDialogComponent>) { }

  ngOnInit() { }

}
